import React from 'react';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import moment from 'moment';

import { validationByJoi } from '../utilities/commonValidation';

import { Edited, PrintPreview } from './modals/Commons';
import dialogLoader from '../utilities/dialogLoader';
import { FieldService } from '../services/Fields';

import { FieldItemInputService } from '../services/FieldItemInputs';
import { PrintService } from '../services/Prints'; // 帳票API

import Helmet from 'react-helmet';
import {
  HEADER_CONSTANTS,
  API_FLAG,
  STATUS_CODE,
} from '../utilities/constants';
import PrintUtility from '../utilities/printUtility';
import { messageUtility } from '../utilities/messageUtility';
import { deleteControlCode } from '../utilities/stringUtil';
import { ToolTip } from '../components/ProgressBase';
import _dialogLoader from '../utilities/dialogLoader';
import { FormInformationDialog } from '../components/FormInformationDialog';

export class FieldItemInputs extends React.Component {
  constructor(props) {
    super(props);

    this.fieldItemListNumbers = [1, 2, 3, 4];
    this.pdfOutput = false; // pdf出力状態

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      workHourZone: sessionStorage.getItem('work_hour_zone'),
      targetDate: sessionStorage.getItem('date_from'),
      isOpened: false,
      fieldItems: [],
      fieldItemCount: 0, // 現場項目設定 - 項目数
      formValues: {},
      errors: {},
      disabledFieldItem: [],
    };

    this.events = {
      form: {
        set: this.setFlatData.bind(this),
        setRadio: this.setRadioData.bind(this),
        submit: this.eventSubmit.bind(this),
        validate: this.validate.bind(this),
      },
      modal: {
        previewModal: this.previewModal.bind(this),
        printOutPreview: this.printOutPreview.bind(this),
      },
    };

    this.schema = {};
  }

  componentDidMount() {
    this.setValidationSchema();
    this.setFieldItemInputs();
  }

  setDisabledFieldItem = fieldItems => {
    const disabledFieldItem = [];
    _.each(this.fieldItemListNumbers, num => {
      if (fieldItems[`field_item_list${num}_progress_using_flag`]) {
        disabledFieldItem.push(num);
      }
    });
    this.setState({ disabledFieldItem });
  };

  setFieldItemInputs() {
    const fieldId = this.state.fieldId;
    Promise.all([
      FieldItemInputService.list(fieldId),
      FieldService.info(fieldId),
    ]).then(responses => {
      if (_.some(responses, response => response.result === 0)) {
        return false;
      }
      const [fieldItemsResponse, fieldInformationResponse] = responses;
      const fieldItems = fieldItemsResponse.data.entities.field_item;
      const fieldInformation = fieldInformationResponse.data.entities.field;
      const fieldItemCount = fieldItems.create_item_count;

      this.setState({
        fieldItems,
        fieldInformation,
        fieldItemCount,
      });
      this.setFormValues(fieldItems, fieldInformation);
      this.setDisabledFieldItem(fieldItems);
    });
  }

  setValidationSchema = () => {
    const validationKeys = {};
    _.each(this.fieldItemListNumbers, num => {
      validationKeys[
        `field_item_list${num}_display_flag`
      ] = Joi.number().required();

      validationKeys[`field_item_list${num}_title`] = Joi.string()
        .max(31)
        .allow(null, '')
        .when(`field_item_list${num}_display_flag`, {
          is: 1,
          then: Joi.string()
            .max(31)
            .required(),
        });
    });
    _.each(_.range(0, this.state.fieldItemCount), num => {
      // rangeで作った配列が0から始まるので
      const itemId = num + 1;
      validationKeys[`option${itemId}_display_flag`] = Joi.number().required();
      if (num <= 3) {
        validationKeys[`option${itemId}_title`] = Joi.string()
          .max(31)
          .required();
      } else {
        validationKeys[`option${itemId}_title`] = Joi.string()
          .max(31)
          .allow(null, '');
      }
      validationKeys[`option${itemId}_print_flag`] = Joi.number().required();
      validationKeys[`option${itemId}_print_width`] = Joi.number().required();
      validationKeys[`option${itemId}_print_flag3`] = Joi.number().required();
      validationKeys[`option${itemId}_print_width3`] = Joi.number().required();
    });
    validationKeys[`oxygen_lack_print_flag`] = Joi.number().required();
    this.schema = Joi.object().keys(validationKeys);
  };

  setFormValues = (values, field) => {
    const formValues = {};
    _.each(this.fieldItemListNumbers, num => {
      formValues[`field_item_list${num}_display_flag`] =
        values[`field_item_list${num}_display_flag`] || 0;
      formValues[`field_item_list${num}_title`] =
        values[`field_item_list${num}_title`] || '';
    });
    _.each(_.range(0, this.state.fieldItemCount), num => {
      // rangeで作った配列が0から始まるので
      const itemId = num + 1;
      console.log('fmv', formValues[`option${itemId}_title`]);
      formValues[`option${itemId}_display_flag`] =
        values[`option${itemId}_display_flag`] || 0;
      formValues[`option${itemId}_title`] =
        values[`option${itemId}_title`] || '';
      formValues[`option${itemId}_must_flag`] =
        values[`option${itemId}_must_flag`] || 0;
      formValues[`option${itemId}_history_flag`] =
        values[`option${itemId}_history_flag`] || 0;
      formValues[`option${itemId}_print_flag`] =
        values[`option${itemId}_print_flag`] || 0;
      formValues[`option${itemId}_print_width`] =
        values[`option${itemId}_print_width`] || 0;
      formValues[`option${itemId}_print_flag3`] =
        values[`option${itemId}_print_flag3`] || 0;
      formValues[`option${itemId}_print_width3`] =
        values[`option${itemId}_print_width3`] || 0;
    });
    formValues.oxygen_lack_print_flag = field.oxygen_lack_print_flag || 0;
    this.setState({
      formValues,
      errors: {},
    });
  };

  setFlatData = e => {
    let formValues = this.state.formValues;
    formValues[e.target.name] = deleteControlCode(e.target.value);
    this.setState({ formValues });
  };

  setRadioData = e => {
    let formValues = this.state.formValues;
    if (formValues[e.target.name] === 1) {
      formValues[e.target.name] = 0;
    } else {
      formValues[e.target.name] = 1;
    }
    this.setState({
      formValues,
    });
  };

  previewModal = () => {
    dialogLoader.show(PrintPreview, {
      state: {
        callbacks: this.events.modal,
      },
    });
  };

  makeReportFileName(reportName, prefix) {
    const timestamp = moment().format('YYYYMMDDHHmmss');
    return `${reportName}_${timestamp}.${prefix}`;
  }

  makePrintParam() {
    const formValues = this.state.formValues;
    const param = {};
    _.each([4, 5, 6], num => {
      param[`option${num}_display_flag`] =
        formValues[`option${num}_display_flag`];
      param[`option${num}_title`] = encodeURIComponent(formValues[`option${num}_title`]);
      param[`option${num}_print_flag`] = formValues[`option${num}_print_flag`];
      param[`option${num}_print_width`] =
        formValues[`option${num}_print_width`];
      param[`option${num}_print_flag3`] =
        formValues[`option${num}_print_flag3`];
      param[`option${num}_print_width3`] =
        formValues[`option${num}_print_width3`];
    });
    param.field_id = this.state.fieldId;
    param.work_hour_zone = this.state.workHourZone;
    param.target_date = this.state.targetDate;
    param.file_code = 2;
    return param;
  }

  printOutPreview = (reportName, reportCode) => {
    if (!this.pdfOutput) {
      this.pdfOutput = true;
      const param = this.makePrintParam();
      param.report_code = reportCode;
      const newTab = window.open('/LayoutPrint', '_blank');
      return PrintService.printReportByReportName(reportName, param)
        .then(async response => {
          this.pdfOutput = false;
          const fileName = PrintService.makeReportFileName(
            reportName,
            param.file_code
          );
          let blob;
          if (_.isUndefined(response.message)) {
            const pdfUrl = response.pdf_s3_url;
            await PrintService.getHeaderReponseURL(pdfUrl.head_pdf_url)
              .then(responseS3AWS => {
                if (responseS3AWS.status === STATUS_CODE.ok) {
                  blob = PrintUtility.convertBase64ToBlob(
                    response.data,
                    'application/pdf'
                  );
                  newTab.location.href = pdfUrl.get_pdf_url;
                }
              })
              .catch(error => {
                newTab.close();
                let result = {
                  result: false,
                  status: error.status,
                  message: messageUtility.getMessage('E-001-401'),
                };
                blob = new Blob([JSON.stringify(result)], {
                  type: 'application/json',
                });
              });
          } else {
            newTab.close();
            blob = new Blob([JSON.stringify(response)], {
              type: 'application/json',
            });
          }
          PrintUtility.printBlob(blob, fileName, param.file_code);
        })
        .catch(error => {
          newTab.close();
          this.pdfOutput = false;
          alert(error);
        });
    }
  };

  //バリデーション
  validate(e) {
    const params = this.state.formValues;
    const result = validationByJoi(this.schema, params);
    const errors = new Object();

    //単数or複数判定
    if (e) {
      if (result.messages[e.target.name]) {
        errors[e.target.name] = result.messages[e.target.name];
      } else if (errors[e.target.name]) {
        delete errors[e.target.name];
      }
    } else {
      if (result.messages) {
        _.each(result.messages, (msg, key) => {
          errors[key] = msg;
        });
      }
    }

    // 作業場所は1つ以上選択が必須
    if (
      params.field_item_list1_display_flag === API_FLAG.Off &&
      params.field_item_list2_display_flag === API_FLAG.Off &&
      params.field_item_list3_display_flag === API_FLAG.Off &&
      params.field_item_list4_display_flag === API_FLAG.Off
    ) {
      errors['field_item_list1_title'] = messageUtility.getMessage('E-000-035');
      errors['field_item_list2_title'] = messageUtility.getMessage('E-000-035');
      errors['field_item_list3_title'] = messageUtility.getMessage('E-000-035');
      errors['field_item_list4_title'] = messageUtility.getMessage('E-000-035');
    }

    this.setState({ errors });
    return Object.keys(errors).length;
  }

  eventSubmit() {
    if (this.validate() !== 0) {
      return;
    }
    const params = this.state.formValues;
    const fieldId = this.state.fieldId;
    FieldItemInputService.update(fieldId, params).then(resp => {
      if (resp.result) {
        const fieldParam = {
          oxygen_lack_print_flag: params.oxygen_lack_print_flag,
        };
        FieldService.oxygenLackUpdate(fieldId, fieldParam).then(resp => {
          if (resp.result) {
            dialogLoader.show(Edited);
            this.setFieldItemInputs();
          }
        });
      } else {
        _dialogLoader.show(FormInformationDialog, {
          buttonText: messageUtility.getMessage('I-000-008'),
          title: messageUtility.getMessage('E-001-402'),
          message: '他のユーザーが更新を行ったため更新することができません。',
          onClose: () => {
            window.location.reload();
          },
        });
      }
    });
  }

  render() {
    return (
      <div className='setting-main__body'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 項目設定</title>
        </Helmet>
        <div id='setting-header' className='setting-header'>
          <div className='setting-header__item'>
            <button
              className='btn--effective'
              onClick={() => this.events.form.submit()}
            >
              更新
            </button>
            <button
              className='btn--sub'
              onClick={() => this.events.modal.previewModal()}
            >
              帳票プレビュー
            </button>
          </div>
        </div>
        <div className='setting-main__table'>
          <table className='setting-table'>
            <thead className='setting-table__header'>
              <tr className='setting-table__label'>
                <td className='value-table item-setting-value-table__item'>
                  <div className='value-table__label'>項目</div>
                </td>
                <td className='value-table item-setting-value-table__item'>
                  <div
                    className='value-table__label'
                    style={{ textAlign: 'center' }}
                  >
                    使用
                  </div>
                </td>
                <td className='value-table item-setting-value-table__item'>
                  <div
                    className='value-table__label'
                    style={{ 'text-align': 'center' }}
                  >
                    必須項目
                  </div>
                </td>
                <td className='value-table item-setting-value-table__item'>
                  <div
                    className='value-table__label'
                    style={{ 'text-align': 'center' }}
                  >
                    履歴入力
                  </div>
                </td>
                <td className='value-table item-setting-value-table__name'>
                  <div className='value-table__label'>表示名</div>
                </td>
                <td className='value-table item-setting-value-table__itemlong'>
                  <div
                    className='value-table__label'
                    style={{ 'text-align': 'center' }}
                  >
                    作業指示書　出力有無/出力幅
                  </div>
                </td>
                <td className='value-table item-setting-value-table__itemlong'>
                  <div
                    className='value-table__label'
                    style={{ 'text-align': 'center' }}
                  >
                    連絡調整実施記録　出力有無/出力幅
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              {getFieldItemList(
                this.fieldItemListNumbers,
                this.state.formValues,
                this.state.errors,
                this.events,
                this.state.disabledFieldItem
              )}
              {getOptionList(
                _.range(4, this.state.fieldItemCount + 1), // 項目1-3は支店項目設定に依存するため設定項目に含まない
                this.state.formValues,
                this.state.errors,
                this.events
              )}
              <tr className='setting-table__item'>
                <td className='item-setting-value-table__item'>酸欠</td>
                <td className='item-setting-value-table__item'>
                  <span className='label'>使用</span>
                  <label
                    htmlFor={`oxygen_lack_print_flag`}
                    className='toggle-radius'
                  >
                    <input
                      type='checkbox'
                      id={`oxygen_lack_print_flag`}
                      name={`oxygen_lack_print_flag`}
                      checked={
                        this.state.formValues.oxygen_lack_print_flag === 1
                      }
                      onClick={e => this.events.form.setRadio(e)}
                    />
                    <i className='i-square i-3x' aria-hidden='true' />
                  </label>
                </td>
                <td className='item-setting-value-table__item'>
                  <span className='label'>必須項目</span>-
                </td>
                <td className='item-setting-value-table__item'>
                  <span className='label'>履歴入力</span>-
                </td>
                <td className='item-setting-value-table__name'>酸欠</td>
                <td className='item-setting-value-table__itemlong'>
                  <span className='label'>作業指示書　出力有無/出力幅</span>-
                </td>
                <td className='item-setting-value-table__itemlong'>
                  <span className='label'>
                    連絡調整実施記録&emsp;出力有無/出力幅
                  </span>
                  -
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const getErrorMessaage = (errors, column) => {
  if (errors[column]) {
    return <div className='validate-message show'>{errors[column]}</div>;
  } else {
    return null;
  }
};

const getFieldItemList = (
  fieldItemListNumbers,
  values,
  errors,
  callbacks,
  disabledFieldItem
) => {
  const message =
    'この項目はBuildee 進捗歩掛で使用しているため、選択を解除できません。' +
    '\n選択を解除したい場合は、進捗歩掛でこの項目を使用している計画を削除するか、作業場所の設定を変更してください。';
  return fieldItemListNumbers.map(num => (
    <tr className='setting-table__item' key={`field_item_list_${num}`}>
      <td className='item-setting-value-table__item'>作業場所{num}</td>
      <td className='item-setting-value-table__item'>
        <span className='label'>使用</span>
        {_.includes(disabledFieldItem, num) ? (
          <div>
            <ToolTip
              content={message}
              value={
                <label
                  htmlFor={`field_item_list${num}_display_flag`}
                  className='toggle-radius'
                >
                  <input
                    type='checkbox'
                    id={`field_item_list${num}_display_flag`}
                    name={`field_item_list${num}_display_flag`}
                    checked={values[`field_item_list${num}_display_flag`] === 1}
                    disabled={true}
                  />
                  <i className='i-square-disabled i-3x' aria-hidden='true' />
                </label>
              }
            />
          </div>
        ) : (
          <label
            htmlFor={`field_item_list${num}_display_flag`}
            className='toggle-radius'
          >
            <input
              type='checkbox'
              id={`field_item_list${num}_display_flag`}
              name={`field_item_list${num}_display_flag`}
              checked={values[`field_item_list${num}_display_flag`] === 1}
              onClick={e => callbacks.form.setRadio(e)}
            />
            <i className='i-square i-3x' aria-hidden='true' />
          </label>
        )}
      </td>
      <td className='item-setting-value-table__item'>
        <span className='label'>必須項目</span>-
      </td>
      <td className='item-setting-value-table__item'>
        <span className='label'>履歴入力</span>-
      </td>
      <td className='item-setting-value-table__name'>
        <input
          type='text'
          className=''
          id={`field_item_list${num}_title`}
          name={`field_item_list${num}_title`}
          value={values[`field_item_list${num}_title`]}
          maxLength={31}
          onChange={e => callbacks.form.set(e)}
          onBlur={e => callbacks.form.validate(e)}
        />
        {getErrorMessaage(errors, `field_item_list${num}_title`)}
      </td>
      <td className='item-setting-value-table__itemlong'>
        <span className='label'>作業指示書　出力有無/出力幅</span>-
      </td>
      <td className='item-setting-value-table__itemlong'>
        <span className='label'>連絡調整実施記録　出力有無/出力幅</span>-
      </td>
    </tr>
  ));
};

const getOptionList = (optionListNumbers, values, errors, callbacks) => {
  return optionListNumbers.map(num => (
    <tr className='setting-table__item' key={`option_${num}`}>
      <td className='item-setting-value-table__item'>予備{num - 3}</td>
      <td className='item-setting-value-table__item'>
        <span className='label'>使用</span>
        <label htmlFor={`option${num}_display_flag`} className='toggle-radius'>
          <input
            type='checkbox'
            id={`option${num}_display_flag`}
            name={`option${num}_display_flag`}
            checked={values[`option${num}_display_flag`] === 1}
            onClick={e => callbacks.form.setRadio(e)}
          />
          <i className='i-square i-3x' aria-hidden='true' />
        </label>
      </td>
      <td className='item-setting-value-table__item'>
        {values[`option${num}_must_flag`] === 0 ? '-' : '必'}
      </td>
      <td className='item-setting-value-table__item'>
        {values[`option${num}_history_flag`] === 0 ? '-' : '有'}
      </td>
      <td className='item-setting-value-table__name'>
        <input
          type='text'
          className=''
          id={`option${num}_title`}
          name={`option${num}_title`}
          value={values[`option${num}_title`]}
          maxLength={31}
          onChange={e => callbacks.form.set(e)}
          onBlur={e => callbacks.form.validate(e)}
        />
        {getErrorMessaage(errors, `option${num}_title`)}
      </td>
      <td className='item-setting-value-table__itemlong'>
        {num >= 4 && num <= 6 ? (
          <React.Fragment>
            <span className='label'>作業指示書　出力有無/出力幅</span>
            <label
              htmlFor={`option${num}_print_flag`}
              className='toggle-radius'
            >
              <input
                type='checkbox'
                id={`option${num}_print_flag`}
                name={`option${num}_print_flag`}
                checked={values[`option${num}_print_flag`] === 1}
                onClick={e => callbacks.form.setRadio(e)}
              />
              <i className='i-square i-3x' aria-hidden='true' />
            </label>
            <select
              id={`option${num}_print_width`}
              name={`option${num}_print_width`}
              value={values[`option${num}_print_width`]}
              onChange={e => callbacks.form.set(e)}
            >
              <option value='1'>小</option>
              <option value='2'>中</option>
              <option value='3'>大</option>
            </select>
          </React.Fragment>
        ) : (
          '-'
        )}
      </td>
      <td className='item-setting-value-table__itemlong'>
        {num >= 4 && num <= 6 ? (
          <React.Fragment>
            <span className='label'>連絡調整実施記録　出力有無/出力幅</span>
            <label
              htmlFor={`option${num}_print_flag3`}
              className='toggle-radius'
            >
              <input
                type='checkbox'
                id={`option${num}_print_flag3`}
                name={`option${num}_print_flag3`}
                checked={values[`option${num}_print_flag3`] === 1}
                onClick={e => callbacks.form.setRadio(e)}
              />
              <i className='i-square i-3x' aria-hidden='true' />
            </label>
            <select
              id={`option${num}_print_width3`}
              name={`option${num}_print_width3`}
              value={values[`option${num}_print_width3`]}
              onChange={e => callbacks.form.set(e)}
            >
              <option value='1'>小</option>
              <option value='2'>中</option>
              <option value='3'>大</option>
            </select>
          </React.Fragment>
        ) : (
          '-'
        )}
      </td>
    </tr>
  ));
};



// WEBPACK FOOTER //
// ./src/pages/FieldItemInputs.jsx